module.exports = {
  businessIntelligenceChartTab: 'แผนภูมิ BI',
  businessIntelligenceDashboardTab: 'แดชบอร์ด BI',
  chartGroupSettingTab: 'การตั้งค่ากลุ่มแผนภูมิ',
  chartConfigurationManagement: 'การจัดการแผนภูมิ BI ของผู้เช่า',
  common: {
    query: 'ค้นหา',
    edit: 'แก้ไข',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    tenantName: 'ชื่อผู้เช่า',
    saveSuccess: 'บันทึกสำเร็จ'
  },
  businessIntelligence: {
    searchKeyword: 'กรุณากรอกคำค้นหา',
    copyChart: 'คัดลอกแผนภูมิและแดชบอร์ด',
    copyAll: 'คัดลอกไปยังผู้เช่าทั้งหมด',
    all: 'ทั้งหมด',
    copyIdRemind: 'กรุณากรอก ID ของวัตถุที่ต้องการคัดลอก',
    copyAllRemind: 'กรุณาเลือกผู้เช่าที่ต้องการคัดลอกไป',
    chartIdPlaceholder: 'กรุณากรอก ID',
    chart: 'แผนภูมิ',
    dashboard: 'แดชบอร์ด',
    type: 'ประเภท',
    copyTo: 'คัดลอกไปยังผู้เช่าบางส่วน',
    copyChartId: 'ID ของวัตถุที่คัดลอก',
    openBiChart: 'เปิดใช้งานแผนภูมิ BI',
    openTenantBiChart: 'เปิดใช้งานแผนภูมิ BI สำหรับผู้เช่า',
    selectTenant: 'การเลือกผู้เช่า',
    keywords: 'กรุณากรอกคำสำคัญ',
    note: 'หมายเหตุ',
    chartNumber: 'แก้ไขจำนวนแผนภูมิของผู้เช่า',
    tenantId: 'ID ผู้เช่า',
    initializeChartNum: 'จำนวนแผนภูมิที่ใช้ได้',
    hasBeenUsedChart: 'จำนวนแผนภูมิที่ใช้แล้ว',
    openingDate: 'วันที่เปิดใช้งาน',
    adjustNumber: 'ปรับจำนวน',
    expirationTime: 'เวลาหมดอายุ',
    selectTime: 'เลือกเวลา',
    adjust1: 'เพิ่ม',
    adjust2: 'ลด',
    available: 'จำนวนแผนภูมิที่ใช้ได้ของผู้เช่า',
    hasBeenUsed: 'จำนวนแผนภูมิที่ใช้แล้วของผู้เช่า',
    noteInformation: 'ข้อมูลหมายเหตุ',
    saveWarning: 'กรุณาเลือกผู้เช่า',
    saveSuccess: 'เปิดใช้งานสำเร็จ',
    copySuccess: 'คัดลอกสำเร็จ',
    editWarning: 'กรุณากรอกจำนวนการปรับให้ครบถ้วน',
    editWarningTime: 'กรุณากรอกเวลาหมดอายุ',
    editSuccess: 'บันทึกสำเร็จ',
    adjustQuantity1: 'ห้ามกรอกจำนวนการปรับเป็นค่าลบ',
    adjustQuantity2: 'จำนวนการลดห้ามมากกว่าจำนวนแผนภูมิของผู้ใช้'
  },
  businessIntelligenceChart: {
    myChartNum: 'จำนวนแผนภูมิของฉัน',
    addChart: 'เพิ่มแผนภูมิที่กำหนดเอง',
    queryChart: 'ค้นหากราฟของฉัน',
    standardChart: 'คลังเทมเพลตกราฟมาตรฐาน BI (กรุณาเลือกกราฟที่ต้องการ)',
    queryStandardChart: 'ค้นหาเทมเพลตกราฟ',
    chartTemplate: 'เทมเพลตกราฟ:',
    classification: 'หมวดหมู่:',
    chartName: 'ชื่อกราฟ',
    chartGrouping: 'กลุ่มกราฟ',
    chartId: 'ค่า ID กราฟ',
    remark: 'หมายเหตุ',
    editChart: 'แก้ไขกราฟผู้ใช้',
    selectAll: 'ทั้งหมด',
    hasChosen: 'เลือกแล้ว',
    notChoose: 'ยังไม่ได้เลือก',
    chartNamePrompt: 'กรุณากรอกชื่อกราฟ',
    chartIdPrompt: 'กรุณากรอกค่า ID กราฟ',
    addSuccess: 'เพิ่มสำเร็จ',
    deleteSuccess: 'ลบสำเร็จ',
    warmPrompt: 'ข้อความแจ้งเตือน',
    warmPromptStatements: '尊敬的租户，您的图表使用数量（${0}张）已达上限，如果需增加图表可使用数量，可联系WallTech在线客服或运行021-65143931咨询了解。',
    confirmButtonText: 'เข้าใจแล้ว'
  },
  chartGroupSetting: {
    viewChart: 'ดูกราฟ',
    newGrouping: 'สร้างกลุ่มใหม่',
    delete: 'ลบ',
    order: 'หมายเลขลำดับ',
    groupName: 'ชื่อกลุ่ม',
    groupNameTips: 'ชื่อกลุ่มไม่สามารถซ้ำกันได้',
    remark: 'หมายเหตุ',
    selectGrouping: 'เลือกกราฟเพื่อเพิ่มในกลุ่ม',
    queryChartName: 'ค้นหาชื่อกราฟ',
    eidtChart: 'แก้ไขกราฟ',
    currentGrouping: 'กลุ่มปัจจุบัน',
    chartDescription: 'คำอธิบายกราฟ',
    addGroup: 'เพิ่มกลุ่มใหม่',
    editGroup: 'แก้ไขกลุ่ม',
    rankRemind: 'กรุณากรอกหมายเลขลำดับกลุ่ม',
    groupingNameRemind: 'กรุณากรอกชื่อกลุ่ม',
    chartNameRemind: 'กรุณากรอกชื่อกราฟ',
    chartGrouping: 'กรุณาเลือกกลุ่มกราฟ',
    deleteSuccess: 'ลบสำเร็จ'
  },
  businessIntelligenceDashboard: {
    addDashboard: 'เพิ่มแดชบอร์ด',
    delete: 'ลบ',
    fullScreen: 'แสดงแบบเต็มหน้าจอ',
    setFilter: 'ตั้งค่าตัวกรอง',
    preview: 'ดูตัวอย่าง',
    saveLayout: 'บันทึกการจัดวาง',
    dragTips: 'คุณสามารถปรับตำแหน่งและขนาดของกราฟได้โดยการลากและวาง',
    addChart: 'เพิ่มกราฟ',
    dashboardType: 'ประเภทแดชบอร์ด',
    customizeDashboard: 'แดชบอร์ดแบบกำหนดเอง',
    biDashboard: 'แดชบอร์ด BI',
    dashboardName: 'ชื่อแดชบอร์ด',
    dashboardId: 'ค่า ID แดชบอร์ด',
    dashboardNamePlaceholder: 'กรุณากรอกชื่อแดชบอร์ด',
    classification: 'หมวดหมู่แดชบอร์ด',
    biDashboardId: 'ค่า ID แดชบอร์ด BI',
    biDashboardIdPlaceholder: 'กรุณากรอกค่า ID แดชบอร์ด',
    Notes: 'หมายเหตุอธิบาย',
    setAccessRights: 'ตั้งค่าสิทธิ์การเข้าถึง',
    selectBranch: 'เลือกสาขา',
    selectBranchPlaceholder: 'กรุณาเลือกบริษัท',
    selectDepartment: 'เลือกแผนก',
    selectDepartmentPlaceholder: 'กรุณาเลือกแผนก',
    selectPersonnel: 'เลือกบุคคล',
    selectPersonnelPlaceholder: 'กรุณาเลือกบุคคล',
    setDataPermission: 'ตั้งค่าสิทธิ์ข้อมูล',
    whole: 'ดูข้อมูลทั้งหมด',
    company: 'ดูข้อมูลสาขา',
    department: 'ดูข้อมูลแผนก',
    personal: 'ดูเฉพาะข้อมูลส่วนตัว',
    rolePermissions: 'ดูข้อมูลตามสิทธิ์บทบาท',
    chartAddDashboard: 'เลือกแผนภูมิเพื่อเพิ่มในแดชบอร์ด',
    queryChartName: 'ค้นหาชื่อแผนภูมิ',
    add: 'เพิ่ม',
    seePreview: '*กรุณาคลิกดูตัวอย่างเพื่อเห็นผลลัพธ์',
    determine: 'ตกลง',
    setQueryItem: 'ตั้งค่าการค้นหาแดชบอร์ด',
    grouping: 'กลุ่ม',
    businessDashboard: 'แดชบอร์ดธุรกิจ',
    financialDashboard: 'แดชบอร์ดการเงิน',
    deleteConfirm: 'ต้องการลบแดชบอร์ดนี้หรือไม่?',
    tips: 'แจ้งเตือน',
    saveTips: 'กรุณาเลือกแผนภูมิเพื่อเพิ่มในแดชบอร์ด',
    saveTips1: 'ชื่อแดชบอร์ดห้ามซ้ำ',
    prompt1: 'ตั้งค่าสิทธิ์การเข้าถึงแดชบอร์ด เช่น สาขาเซี่ยงไฮ้ แผนกปฏิบัติการ จางซาน',
    prompt2: 'หากตั้งค่าเฉพาะสาขา บุคคลทั้งหมดในบริษัทจะสามารถเข้าถึงได้',
    prompt3: 'สิทธิ์ข้อมูลสามารถจำกัดขอบเขตการมองเห็นข้อมูลของผู้ใช้ปัจจุบัน',
    prompt4: 'ตัวอย่าง: เฉพาะส่วนตัว หมายถึงเห็นเฉพาะข้อมูลธุรกิจของตนเอง',
    prompt5: 'สามารถติดต่อฝ่ายบริการออนไลน์ WallTech หรือโทร 021-65143931 เพื่อสอบถามข้อมูลเพิ่มเติม!',
    prompt6: 'เรียนผู้เช่า หากต้องการทราบและใช้งานแอปพลิเคชัน BI เพิ่มเติม สามารถติดต่อฝ่ายบริการออนไลน์ WallTech หรือโทร 021-65143931 เพื่อขอคำปรึกษา'
  }
}
